import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disableAutoPositioning"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { useCrossAppID } from '../crossAppID';
const DISPLAY_NAME = 'StickyBarGroup';
const Root = styled.div.withConfig({
  displayName: "StickyBarGroup__Root",
  componentId: "sc-11uqqge-0"
})(["display:flex;flex-direction:column;", " &,> *{width:100%;}"], _ref => {
  let {
    $autoPositioning
  } = _ref;
  return $autoPositioning && css(["position:fixed;top:0;left:0;z-index:calc(var(--zindex-2) + 1);"]);
});
const StickyBarGroup = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
      children,
      disableAutoPositioning
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  const [crossAppProps] = useCrossAppID(DISPLAY_NAME, {
    disabled: disableAutoPositioning
  });
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, crossAppProps, {
    ref: ref,
    $autoPositioning: !disableAutoPositioning
  }), children);
});
StickyBarGroup.displayName = DISPLAY_NAME;
StickyBarGroup.Style = Root;
StickyBarGroup.defaultProps = {
  disableAutoPositioning: false
};
process.env.NODE_ENV !== "production" ? StickyBarGroup.propTypes = {
  /**
   * Sets the children.
   */
  children: PropTypes.node,
  /**
   * Disables automatic positioning of the component.
   * If this property is `true`, the component positioning must be provided by some external means.
   */
  disableAutoPositioning: PropTypes.bool
} : void 0;
export default StickyBarGroup;